import { Redirect, withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';

import { isAuthenticated, isService } from '../utils';

import Route from './SentryRoute';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() && !isService() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

PrivateRoute.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  component: PropTypes.elementType,
};

export default withRouter(PrivateRoute);
